import React from 'react';

/**
 * Header responsive per le pagine del Pannello Gestore.
 * - Mobile: titolo sopra, azioni impilate sotto (full width).
 * - Desktop: titolo a sinistra, azioni allineate a destra.
 */
export const GestorePageHeader = ({ title, subtitle, children }) => (
  <div
    data-testid="gestore-page-header"
    className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between mb-5 md:mb-6"
  >
    <div className="min-w-0">
      <h1 className="font-display text-2xl md:text-3xl font-black tracking-tight">{title}</h1>
      {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {children && (
      <div className="flex flex-col gap-2 sm:flex-row sm:flex-wrap md:justify-end [&>*]:w-full sm:[&>*]:w-auto">
        {children}
      </div>
    )}
  </div>
);
